export default function LegalPrivacy() {
  return (
    <section id="privacy" className="legal-section">
      <h2 className="legal-section-title">Privacy Policy</h2>
      <p className="legal-meta">Last Updated: {new Date().toISOString().slice(0, 10)}</p>

      <h3>1. Introduction</h3>
      <p>
        VoyagerBug (&quot;we,&quot; &quot;us,&quot; or &quot;our&quot;) respects your privacy. This Privacy Policy explains how we
        collect, use, store, and protect your personal information when you use Pista (the &quot;App&quot;).
      </p>
      <p>
        By using the App, you consent to the practices described in this Privacy Policy. If you do not
        agree, please do not use the App.
      </p>

      <h3>2. Information We Collect</h3>
      <ul>
        <li>
          <strong>Account Information:</strong> When you create an account, we collect your email
          address, username, and password. We may also collect your BGG username if you choose to
          link it.
        </li>
        <li>
          <strong>Usage Data:</strong> We collect information about how you interact with the App,
          including game searches, recommendations, sessions, and preferences.
        </li>
        <li>
          <strong>Device &amp; Log Data:</strong> We may collect your IP address, device type, browser
          type, operating system, and app crash logs.
        </li>
        <li>
          <strong>Cookies &amp; Similar Technologies:</strong> We use cookies and similar technologies
          to remember preferences and improve the App. See our{" "}
          <a href="#cookies">Cookie Policy</a> for details.
        </li>
      </ul>

      <h3>3. How We Use Your Information</h3>
      <ul>
        <li>To provide, maintain, and improve the App.</li>
        <li>To personalise game recommendations and suggestions.</li>
        <li>To communicate with you about updates, promotions, and support.</li>
        <li>To process payments and manage subscriptions.</li>
        <li>To analyse usage trends and improve user experience.</li>
        <li>To comply with legal obligations.</li>
      </ul>

      <h3>4. How We Share Your Information</h3>
      <p>We do not sell your personal data. We may share information:</p>
      <ul>
        <li>
          <strong>With Service Providers:</strong> We use third-party services (e.g., hosting, analytics,
          payment processing) that process data on our behalf under strict confidentiality agreements.
        </li>
        <li>
          <strong>For Legal Reasons:</strong> We may disclose information if required by law, court
          order, or to protect our rights, users, or others.
        </li>
        <li>
          <strong>Business Transfers:</strong> In the event of a merger, acquisition, or sale of assets,
          your information may be transferred as part of that transaction.
        </li>
      </ul>

      <h3>5. Data Retention</h3>
      <p>
        We retain your personal data only as long as necessary to provide the App and fulfil the
        purposes described in this Privacy Policy. When you delete your account, we will delete or
        anonymise your data, except where retention is required by law.
      </p>

      <h3>6. Your Rights</h3>
      <p>Depending on your location, you may have the right to:</p>
      <ul>
        <li>Access, correct, or delete your personal data.</li>
        <li>Object to or restrict certain types of processing.</li>
        <li>Withdraw consent where processing is based on consent.</li>
        <li>Request a copy of your data in a portable format.</li>
      </ul>
      <p>
        To exercise these rights, contact us at{" "}
        <a href="mailto:threads@voyagerbug.com">threads@voyagerbug.com</a>.
      </p>

      <h3>7. Security</h3>
      <p>
        We implement appropriate technical and organisational measures to protect your data. However,
        no method of transmission over the internet is completely secure, and we cannot guarantee
        absolute security.
      </p>

      <h3>8. Children&apos;s Privacy</h3>
      <p>
        The App is not intended for children under 13. We do not knowingly collect personal data from
        children under 13. If you believe we have collected such data, please contact us.
      </p>

      <h3>9. International Transfers</h3>
      <p>
        Your data may be stored and processed in countries outside your country of residence, including
        the United Kingdom. We ensure appropriate safeguards are in place for any such transfers.
      </p>

      <h3>10. Third-Party Links</h3>
      <p>
        The App may contain links to third-party websites or services. We are not responsible for the
        privacy practices of those third parties.
      </p>

      <h3>11. Changes to This Privacy Policy</h3>
      <p>
        We may update this Privacy Policy from time to time. We will notify you of material changes
        via email or through the App. Continued use of the App after changes constitutes acceptance
        of the updated policy.
      </p>

      <h3>12. Contact Us</h3>
      <p>
        If you have questions about this Privacy Policy, contact us at{" "}
        <a href="mailto:threads@voyagerbug.com">threads@voyagerbug.com</a>.
      </p>
    </section>
  );
}
